import React, { useRef, useState } from "react";
import WaterSetup from "./water/WaterSetup";
import ChemicalRanges from "./water/ChemicalRanges";
import WaterLayoutEditor from "./client/WaterLayoutEditor";

// "Chemicals & Print": Water Test Setup, Water Test Layout and Chemical Ranges behind one PIN.
const TABS = [["setup", "Water Test Setup"], ["layout", "Water Test Layout"], ["ranges", "Chemical Ranges"]];

export default function ChemicalsPrint({ closeRef }) {
  const [tab, setTab] = useState("setup");
  const layoutClose = useRef(null);
  // the layout editor saves when you leave it, same as closing its own popup
  const leaveLayout = async () => (tab === "layout" ? (await layoutClose.current?.()) !== false : true);
  if (closeRef) closeRef.current = leaveLayout;
  const go = async (t) => { if (t !== tab && (await leaveLayout())) setTab(t); };
  return (
    <div data-testid="chemicals-print">
      <div className="flex gap-1 border-b border-slate-300 mb-3" role="tablist">
        {TABS.map(([k, l]) => (
          <button key={k} role="tab" aria-selected={tab === k} onClick={() => go(k)} data-testid={`chem-tab-${k}`}
            className={`px-4 py-2 text-[13px] font-bold rounded-t-md border border-b-0 -mb-px transition-colors ${tab === k ? "bg-white border-slate-300 text-[#1f4e86]" : "bg-slate-100 border-transparent text-slate-600 hover:bg-slate-200"}`}>{l}</button>
        ))}
      </div>
      {tab === "setup" && <WaterSetup />}
      {tab === "layout" && <WaterLayoutEditor closeRef={layoutClose} />}
      {tab === "ranges" && <ChemicalRanges />}
    </div>
  );
}
